import { useEffect, useState, memo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchPostData } from '@/Components/hooks/Api';
import { get_LocalStoreData } from '@/redux/api';
import { Decrypt_Id_Name, tableCustomStyles } from '@/Components/Common/Utility';
import NameListing from '@/Components/Pages/ShowAllList/NameListing';
import DataTable from '@/Components/Common/DataTableWithAutoPagination';
const DocumentName = (props) => {

  const { DecNameID, DecMasterNameID, DecIncID, ListData } = props
  const dispatch = useDispatch();
  const localStoreData = useSelector((state) => state.Agency.localStoreData);
  const uniqueId = sessionStorage.getItem('UniqueUserID') ? Decrypt_Id_Name(sessionStorage.getItem('UniqueUserID'), 'UForUniqueUserID') : '';

  const [loginPinID, setLoginPinID,] = useState('');
  const [nameID, setNameID] = useState('');
  const [masterNameID, setMasterNameID] = useState('');
  const [incidentID, setIncidentID] = useState();
  const [documentData, setDocumentData] = useState();
  const [loginAgencyID, setLoginAgencyID] = useState('');

  useEffect(() => {
    if (!localStoreData?.AgencyID || !localStoreData?.PINID) {
      if (uniqueId) dispatch(get_LocalStoreData(uniqueId));
    }
  }, []);

  useEffect(() => {
    if (localStoreData) {
      setLoginPinID(localStoreData?.PINID);
      setLoginAgencyID(localStoreData?.AgencyID);
    }
  }, [localStoreData]);

  useEffect(() => {
    if (DecNameID) {
      setNameID(DecNameID);
      setIncidentID(DecIncID);
    }
    if (DecMasterNameID) {
      setMasterNameID(DecMasterNameID)
    }
  }, [DecNameID, loginPinID, DecMasterNameID]);


  useEffect(() => {
    if (loginPinID && (masterNameID || (incidentID && nameID))) {
      get_DocumentData(nameID, masterNameID, incidentID, loginPinID);
    }
  }, [loginPinID, nameID, DecMasterNameID, incidentID]);

  const get_DocumentData = (nameID, masterNameID, incidentID, loginPinID,) => {
    const val = {
      'IncidentID': nameID ? incidentID : '',
      'PINID': loginPinID,
      'SelectDocumentTypeValue': nameID ? nameID : '',
      'MasterNameID': nameID ? '' : masterNameID,
      'DocumentTypeId': 2,
    }
    fetchPostData('MasterName/GetIncidentNameDocuments', val).then((res) => {
      if (res) { setDocumentData(res); }
      else { setDocumentData([]); }
    })
  }

  const columns = [
    {
      width: '120px',
      name: (
        <p className="text-end" style={{ position: 'absolute', top: 8 }}>
          View Attachment
        </p>
      ),
      cell: row => (
        <div className="div" style={{ position: 'absolute', top: 4, left: 20 }}>
          <span
            onClick={() => {
              window.open(row?.FileAttachment);
            }}
            className={`btn btn-sm bg-green text-white px-1 py-0`}
            style={{ cursor: 'pointer' }}
          >
            <i className="fa fa-eye" />
          </span>
        </div>
      ),
    },
    {
      name: 'Document Name', selector: (row) => row.DocumentName, sortable: true
    },
    {
      name: 'Document Permission', selector: (row) => row.DocumentType_Description, sortable: true
    },
    {
      name: 'Document Owner', selector: (row) => row.OwnerName, sortable: true
    },
  ]

  return (
    <>
      <NameListing {...{ ListData }} />
      <div className="col-md-12">
        <DataTable
          dense
          columns={columns}
          pagination
          highlightOnHover
          customStyles={tableCustomStyles}
          data={documentData}
          noDataComponent={"There are no data to display"}
          fixedHeader
          persistTableHead={true}
          fixedHeaderScrollHeight='300px'
          paginationPerPage={'100'}
          paginationRowsPerPageOptions={[100, 150, 200, 500]}
        />
      </div>
    </>
  )
}

export default memo(DocumentName)